export enum BlackoutAction {
  /**
   * Represents that the content is allowed to continue playback
   */
  ALLOW = 'ALLOW',

  /**
   * Represents that the content is denied playback
   */
  DENY = 'DENY',

  /**
   *  Represents that the content is denied playback but allowed with subscription upgrade
   */
  ALLOW_WITH_UPGRADE = 'ALLOW_WITH_UPGRADE',
}
